// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import StyledComponent from '~/components/Styled/Styled';
import StatBar from '~/components/StatBar/StatBar';
import CardHeader from '~/components/CardHeader/CardHeader';
import { TeamStat } from '~/schemas/teamStats/index.d';
import { injectIntl } from 'react-intl';
import css from './TeamStats.scss';

interface TeamStatsProps {
  homeTeamName: string;
  awayTeamName: string;
  stats: TeamStat[];
  intl: any;
}

interface StatValues {
  name: string;
  awayStat: string | number;
  awayRank?: string | number;
  awayPercent: string | number;
  homeRank?: string | number;
  homeStat: string | number;
  homePercent: string | number;
  isNegativeStat?: boolean;
  isBarHidden?: boolean;
}

// tslint:disable-next-line variable-name
export const TeamStats: React.FC<TeamStatsProps> = props => {
  const asProps = props.stats.map(stat => {
    const isFormation = stat.name.toLowerCase() === 'formation';

    const statValues: StatValues = {
      name: stat.localized_name ? props.intl.formatMessage(stat.localized_name) : stat.name,
      awayPercent: stat.away.percentage,
      awayStat: stat.away.value,
      awayRank: stat.away.meta,
      homePercent: stat.home.percentage,
      homeStat: stat.home.value,
      homeRank: stat.home.meta,
      isNegativeStat: stat.isNegative,
      isBarHidden: isFormation,
    };
    return statValues;
  });

  return (
    <div>
      <CardHeader>
        <div className={css.awayTeamName}>{props.awayTeamName}</div>
        <div className={css.homeTeamName}>{props.homeTeamName}</div>
      </CardHeader>

      {!asProps || asProps.length === 0 ? <div className={css.noData}>None</div> : null}

      {asProps.map(stat => (
        <StatBar
          key={`stat-${stat.name}`}
          team1Stat={stat.awayStat}
          team1Rank={stat.awayRank}
          team1Percent={stat.awayPercent}
          team2Stat={stat.homeStat}
          team2Rank={stat.homeRank}
          team2Percent={stat.homePercent}
          statName={stat.name}
          isNegativeStat={stat.isNegativeStat}
          isBarHidden={stat.isBarHidden}
        />
      ))}
    </div>
  );
};

TeamStats.displayName = 'TeamStats';

TeamStats.propTypes = {
  stats: PropTypes.array,
  intl: PropTypes.object,
  homeTeamName: PropTypes.string,
  awayTeamName: PropTypes.string,
};

TeamStats.defaultProps = {
  stats: [],
  intl: {},
  homeTeamName: '',
  awayTeamName: '',
};

export default injectIntl(StyledComponent(TeamStats, [css]));
